import { useEffect, useRef, useCallback } from 'react';

export function useAlarmAudio(enabled: boolean) {
  const ctxRef = useRef<AudioContext | null>(null);
  const playRef = useRef<() => void>(() => {});

  useEffect(() => {
    if (!enabled) {
      if (ctxRef.current) {
        ctxRef.current.close().catch(() => {});
        ctxRef.current = null;
      }
      playRef.current = () => {};
      return;
    }
    const AC = (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!AC) {
      playRef.current = () => {};
      return;
    }
    const ctx = new AC();
    ctxRef.current = ctx;

    playRef.current = () => {
      if (!ctxRef.current) return;
      const c = ctxRef.current;
      if (c.state === 'suspended') c.resume().catch(() => {});
      const t = c.currentTime;
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.connect(gain);
      gain.connect(c.destination);
      osc.type = 'sine';
      // Two-tone beep: 880 Hz then 1100 Hz
      osc.frequency.setValueAtTime(880, t);
      osc.frequency.setValueAtTime(1100, t + 0.12);
      gain.gain.setValueAtTime(0.08, t);
      gain.gain.setValueAtTime(0.08, t + 0.12);
      gain.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
      osc.start(t);
      osc.stop(t + 0.35);
    };

    return () => {
      ctxRef.current?.close().catch(() => {});
      ctxRef.current = null;
      playRef.current = () => {};
    };
  }, [enabled]);

  return useCallback(() => playRef.current(), []);
}
